import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';

import {MatIconModule} from '@angular/material/icon';
import {MatDialogRef} from '@angular/material/dialog';

import {SitesQuery} from '../../../common/elf-store/sites/sites.query';
import {SUBSCRIPTIONS} from '../../../common/utils/constants';
import {AutoUnsubscribe} from 'src/app/decorators/auto-unsubscribe.decorator';
import {ISiteStatus, SiteSearchEntryDto} from '../../../../userway/sdk/UserWayApiClient';
import {Router} from '@angular/router';
import {TrialSiteService} from '../../../services/trial-site.service';
import {MySitesApiService} from '../../../services/api/my-sites-api.service';
import {finalize, of, take} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {BtnComponent} from '../../dumb/button/button.component';
import {DialogComponent} from '../../dumb/dialog/dialog.component';
import {ProgressSpinnerComponent} from '../../dumb/progress-spinner/progress-spinner.component';

@AutoUnsubscribe()
@Component({
  standalone: true,
  selector: 'mc-trial-expired-no-card-dialog',
  imports: [BtnComponent, DialogComponent, MatIconModule, ProgressSpinnerComponent],
  templateUrl: './trial-expired-no-card-dialog.component.html',
  styleUrl: './trial-expired-no-card-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialExpiredNoCardDialogComponent implements OnInit {
  loading: boolean = true;
  currentSite: SiteSearchEntryDto;

  sitesQuery = inject(SitesQuery);
  dialogRef = inject(MatDialogRef<TrialExpiredNoCardDialogComponent>);
  router = inject(Router);
  trialSiteService = inject(TrialSiteService);
  private mySitesApiService = inject(MySitesApiService);

  ngOnInit() {
    this[SUBSCRIPTIONS].add(
      this.sitesQuery.activeSites$.subscribe(data => {
        if (!data.sites) {
          return;
        }
        this.currentSite = data.sites[0];
        this.loading = false;
      }),
    );
  }

  close() {
    this.dialogRef.close();
  }

  handleSiteUpgrade(): void {
    this.loading = true;

    if (this.currentSite) {
      this.upgrade(this.currentSite);
      return;
    }

    this.mySitesApiService
      .mySites({p: 1, q: 999999, status: ISiteStatus.ACTIVE})
      .pipe(
        take(1),
        catchError(err => {
          return of({sites: []});
        }),
      )
      .subscribe(({sites}) => {
        const site = sites?.[0];
        if (site) {
          this.upgrade(site);
        }
      });
  }

  private upgrade(site: SiteSearchEntryDto): void {
    this.trialSiteService.upgrade(site, () => {
      this.loading = false;
      this.close();
    });
  }
}
